var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { FacetTypeTable, FacetFactory } from "flavr-common";
import { modelPool } from "@modules/model";
export class BlueprintParserClient {
    static parse(blueprint, parent) {
        return __awaiter(this, void 0, void 0, function* () {
            const models = [];
            if (blueprint.fileId !== undefined)
                return models;
            if (blueprint.models === undefined)
                return models;
            if (!Array.isArray(blueprint.models))
                throw new TypeError(`models isn't a array`);
            for (const blueprintModel of blueprint.models) {
                this.parseModel(blueprintModel, parent);
            }
            return models;
        });
    }
    static parseModel(blueprintModel, parent) {
        if (typeof blueprintModel.relativeId !== "string")
            throw new TypeError("relativeId isn't a string");
        const model = modelPool.createModel(blueprintModel.relativeId, parent);
        this.parseFacets(blueprintModel, model);
        if (blueprintModel.children) {
            if (!Array.isArray(blueprintModel.children))
                throw new TypeError(`children isn't an array`);
            for (const blueprintChildren of blueprintModel.children) {
                this.parseModel(blueprintChildren, model);
            }
        }
    }
    static parseFacets(blueprintModel, model) {
        if (!blueprintModel.facets) {
            return;
        }
        if (typeof blueprintModel.facets !== "object")
            throw new TypeError(`facets isn't a object`);
        for (const facetType in blueprintModel.facets) {
            const obj = blueprintModel.facets[facetType];
            this.parseFacet(facetType, obj, model);
        }
    }
    static parseFacet(facetType, blueprintFacet, model) {
        if (!FacetTypeTable.getHash(facetType))
            return;
        const facet = FacetFactory.createFromObjectByTypeString(blueprintFacet, facetType, true);
        if (!facet)
            return;
        model.setFacet(facet);
    }
}
